/**
 * Whether a caught HTTP error is specifically the Pro-membership gate's
 * 403 (`{ error: 'pro_required' }`), as opposed to some other 403 the
 * endpoint might return for an unrelated reason. Angular's HttpClient nests
 * a non-2xx response body under `.error` on the thrown `HttpErrorResponse`,
 * so the Hub's `{ error: 'pro_required' }` body lands at `error.error.error`.
 * Checking the status alone would silently swallow and redirect away from a
 * DIFFERENT 403 (auth/policy failure unrelated to tier) instead of
 * surfacing it as a real error (Copilot catch on
 * american-drone-network-web PR #120).
 *
 * Lives in its own Angular-free file — not inlined in a service — so spec
 * files can import the REAL function a service's catch block calls instead
 * of a hand-copied duplicate that could silently drift from the real branch
 * condition (same PR's other Copilot catch). A service file itself can't be
 * imported from a spec in this repo's Jest config: it has no
 * `transformIgnorePatterns` for Angular's ESM-only packages, so a bare
 * `import ... from '@angular/core'` (which every service file has, even
 * just for `Injectable`/`inject`) fails to parse — confirmed by running
 * this file's sibling TestBed+jasmine-style specs (dashboard, faa-report,
 * logbook-overview, member-onboarding-progress, team-report), all of which
 * fail to even compile here. Same reasoning as `membership-tier-utils.ts`
 * and `sidebar-tier-utils.ts`.
 */
export function isProRequiredError(error: unknown): boolean {
  const httpError = error as { status?: number; error?: { error?: string } } | null | undefined;
  return httpError?.status === 403 && httpError?.error?.error === 'pro_required';
}
